var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close"},[_c('svg',{attrs:{"height":_vm.size,"width":_vm.size}},[_c('line',{style:(_vm.styleObj),attrs:{"x1":"2","y1":"2","x2":_vm.diff,"y2":_vm.diff}}),_c('line',{style:(_vm.styleObj),attrs:{"x1":_vm.diff,"y1":"2","x2":"2","y2":_vm.diff}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }